import { useState } from "react";
import { Crown, Flame, Trophy } from "lucide-react";

export const GameArt = ({ src, kind = "season", label, testId, className = "" }) => {
  const [failedSource, setFailedSource] = useState(null);
  const Icon = kind === "crown" ? Crown : kind === "streak" ? Flame : Trophy;
  return <span className={`game-art game-art-${kind} ${className}`} data-testid={testId}>
    {src && failedSource !== src ? <img src={src} alt={label} onError={() => setFailedSource(src)} />
      : <span className="game-art-fallback" role="img" aria-label={label} data-testid={`${testId}-fallback`}><Icon aria-hidden size={kind === "season" ? 40 : 22} /></span>}
  </span>;
};